import { useContext } from 'react';
import {
  IAppContext,
  IContentContext,
  INavLinkContext,
  IPanelContext,
} from 'component/layout/types';
import {
  AppLayoutContext,
  ContentLayoutContext,
  NavLinkLayoutContext,
  PanelLayoutContext,
} from '../Contexts';

export const useAppLayoutContext = (): IAppContext =>
  useContext(AppLayoutContext);
export const useContentLayoutContext = (): IContentContext =>
  useContext(ContentLayoutContext);
export const useNavLinkLayoutContext = (): INavLinkContext =>
  useContext(NavLinkLayoutContext);
export const usePanelLayoutContext = (): IPanelContext =>
  useContext(PanelLayoutContext);
